<template>
    <div class="questions">
        <section class="config-form primary title">
            <div class="content-text">
                <div class="title">
                    <h2>
                        {{name}} 
                    </h2>
                </div>
            </div>

            <div class="button action" >
                <button v-show="hasChange" @click="updateinfo" type="button" class="btn btn-success">Salvar</button>
                <button @click="" type="button" class="btn btn-secondary">Novo</button>
            </div>
        </section>
        <section class="config-form primary" v-for="questions,i in data">
            <div class="content-text">
                <div class="title quiz" >
                    <h4>{{ i+1  }} -     {{questions.name}}</h4>
                    <div class="buttons" >
                    <button type="button" class="btn btn-light">
                        <i class="pi pi-pencil"></i>
                    </button>
                    <button type="button" class="btn btn-light" @click="showHide(i)">
                        <i class="pi" :class="[show[i] == true ? 'pi-eye' : 'pi-eye-slash' ]"></i>
                    </button>
                    <div class="button-order">
                        <button type="button" class="btn btn-light" @click="moveUp(i)"> <i class="pi pi-chevron-circle-up"></i> </button>
                        <button type="button" class="btn btn-light" @click="moveDown(i)"> <i class="pi pi-chevron-circle-down"></i> </button>
                    </div>
                </div>
                </div>
                <div class="answer_quiz" v-for="(asnwer, index ) in questions.asnwers" v-show="show[i]">
                    <input :class="[questions.correctOption == index ? 'correct' : '']" type="text" class="form-control" :placeholder="option[index]+' - '+asnwer" disabled>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default{
    data(){
        return{
            data:[],
            show:[],
            option:['A','B','C','D','E'],
            name:'',
            hasChange:false,
        }
    },
    methods:{
        showHide(index){
            this.show[index]=!this.show[index];
        },
        moveUp(index) {
            if (index > 0) {
                
                const itemToMove = this.data[index];
                this.data.splice(index, 1);
                this.data.splice(index - 1, 0, itemToMove);
                }
            this.hasChange=true;
        },
        moveDown(index) {
        if (index < this.data.length - 1) {
            const itemToMove = this.data[index];
            this.data.splice(index, 1);
            this.data.splice(index + 1, 0, itemToMove);
        }
        this.hasChange=true;
         },
         updateinfo(){
         }
    },
    created(){
        this.name = "Quiz de Ciências - Sistema Solar"
        this.data = [
            {
                name:" Qual das seguintes afirmações sobre o Sol é verdadeira? ",
                correctOption: '1',
                asnwers:[
                    'O Sol é um planeta no nosso sistema solar.',
                    'O Sol é composto principalmente de gás hidrogênio e hélio.',
                    'O Sol é maior do que qualquer planeta do sistema solar.',
                    'O Sol é um corpo celeste feito principalmente de rocha e metal.',
                    'O Sol é mais próximo da Terra do que a Lua.'
                ],
            },
            {
                name:" Qual das seguintes afirmações sobre a Lua é verdadeira?",
                correctOption: '2',
                asnwers:[
                    'O Sol é um planeta no nosso sistema solar.',
                    'O Sol é composto principalmente de gás hidrogênio e hélio.',
                    'O Sol é maior do que qualquer planeta do sistema solar.',
                    'O Sol é um corpo celeste feito principalmente de rocha e metal.',
                    'O Sol é mais próximo da Terra do que a Lua.'
                ],
            },
            {
                name:" Qual das seguintes afirmações sobre os planetas do sistema solar é verdadeira?",
                correctOption: '4',
                asnwers:[
                    'O Sol é um planeta no nosso sistema solar.',
                    'O Sol é composto principalmente de gás hidrogênio e hélio.',
                    'O Sol é maior do que qualquer planeta do sistema solar.',
                    'O Sol é um corpo celeste feito principalmente de rocha e metal.',
                    'O Sol é mais próximo da Terra do que a Lua.'
                ],
            },
        ];

        for (let i = 0; i< this.data.length -1;i++){
            if(i==0){
                this.show[i] = true;
            } else {
            this.show[i]=false
            }
        }
        
       
    },
}
</script>

<style>
input.correct.form-control {
    font-weight: 700;
}
.answer_quiz {
    margin: 5px 0px;
}
section.config-form.primary.title {
    display: flex;
    justify-content: space-between;
}
</style>